import { Configuration as V2Configuration } from '../v2';
import { BASE_PATH as V2Base } from '../v2/base';

export enum MNSproCloudApiEndpoint {
  Local = 'https://localhost/',
  Preview = 'https://api-preview.mnspro.cloud',
  Rc = 'https://api-rc.mnspro.cloud',
  Production = 'https://api.mnspro.cloud',
}

/**
 * This method will check if a manual endpoint was provided.
 * Otherwise it will use the "REACT_APP_MNSPROCLOUD_API_ENDPOINT_URL" env-variable to override
 * the default endpoint.
 *
 * If nothing matches, the provided fallback endpoint will be used.
 *
 * @param {(MNSproCloudApiEndpoint | undefined)} configuredEndpoint
 * @param {string} fallbackEndpoint
 * @return {*}
 */
const resolveEndpoint = (
  configuredEndpoint: MNSproCloudApiEndpoint | undefined,
  fallbackEndpoint: string,
) => {
  const endpointOverride = process.env.REACT_APP_MNSPROCLOUD_API_ENDPOINT_URL;

  if (!configuredEndpoint && endpointOverride) {
    return endpointOverride;
  }

  return configuredEndpoint ?? fallbackEndpoint;
};

/**
 * Creates an MNSpro Cloud API V2 configuration object for axios which contains
 * the given bearer token as part of the headers and the given
 * api endpoint url as basePath. If no endpoint is specified,
 * the base url of the generated api will be used.
 *
 * @param {string} authToken JWT  (without 'Bearer'-prefix)
 * @param {*} [apiEndpoint=MNSproCloudApiEndpoint.Production] Default: undefined.
 * @return {*}  {Configuration}
 */
export function createV2Configuration(
  authToken: string,
  apiEndpoint?: MNSproCloudApiEndpoint | undefined,
  tokenType?: 'api' | 'bearer',
): V2Configuration {
  const basePath = resolveEndpoint(apiEndpoint, V2Base);
  return new V2Configuration({
    basePath,
    baseOptions: {
      headers: {
        Authorization: `${
          tokenType === 'api' ? 'ApiKey' : 'Bearer'
        } ${authToken}`,
      },
    },
  });
}
